<ul>
  @switch (role?.name) {
    @case (roleType.DEVELOPER) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.ADMIN) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.ARCHITECT) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.SYSTEM_ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.GENESYS_CLOUD_VOICE_ADMIN) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.TELEPHONY_ADMIN) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.COMMUNICATE_ADMIN) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.OUTBOUND_ADMIN) {
      <ng-container *ngTemplateOutlet="regionalEvents"></ng-container>
    }
    @case (roleType.WEM_QUALITY_ADMINISTRATOR) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.WEM_QUALITY_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.WEM_PERFORMANCE_MANAGEMENT_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.WEM_PLANNER_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.WEM_PLANNING_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.MASTER_ADMIN) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @case (roleType.SUPERVISOR) {
      <ng-container *ngTemplateOutlet="WEMEvents"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
    }
  }
</ul>

<ng-template #regionalEvents>
  @switch (region) {
    @case (regionCode.NA) {
      <ng-container *ngTemplateOutlet="NAEvents"></ng-container>
    }
    @case (regionCode.LATAM) {
      <ng-container *ngTemplateOutlet="NAEvents"></ng-container>
    }
    @case (regionCode.EMEA) {
      <ng-container *ngTemplateOutlet="EMEAEvents"></ng-container>
    }
    @case (regionCode.APAC) {
      <ng-container *ngTemplateOutlet="APACEvents"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
    }
  }
</ng-template>

<!--Default Events for All Roles -->
<ng-template #defaultsEventForAllRoles>
  <li>
    <a
      class="overlay-link"
      href="https://orchestrators.genesys.com/education?product=genesys-cloud-cx#webinars"
      target="_blank"
      title="Genesys Cloud Webinars"
      >Webinars</a
    >
  </li>
  <li>
    <a
      class="overlay-link"
      href="https://orchestrators.genesys.com/resources/genesys-news-and-events?product=genesys-cloud-cx#events"
      target="_blank"
      title="Genesys Events"
      >Genesys Events</a
    >.
  </li>
</ng-template>

<!--North America (NA) Events-->
<ng-template #NAEvents>
  <li>
    <a class="overlay-link" href="https://www.genesys.com/events" target="_blank" title="Genesys Events"
      >Genesys Events</a
    >
  </li>
  <li>
    <a
      class="overlay-link"
      href="https://www.genesys.com/events/gcsm-workshop"
      target="_blank"
      title="Customer Success How To Workshops"
      >Customer Success Workshops</a
    >
  </li>
  <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
</ng-template>

<!--APAC Events-->
<ng-template #APACEvents>
  <li>
    <a class="overlay-link" href="https://www.genesys.com/events" target="_blank" title="Genesys Events"
      >Genesys Events</a
    >
  </li>
  <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
</ng-template>

<!--EMEA Events-->
<ng-template #EMEAEvents>
  <li>
    <a class="overlay-link" href="https://www.genesys.com/events" target="_blank" title="Genesys Events"
      >Genesys Events</a
    >
  </li>
  <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
</ng-template>

<!--LATAM Events-->
<ng-template #LATAMEvents>
  <li>
    <a
      class="overlay-link"
      href="https://www.genesys.com/es-mx/events?type=webinar"
      target="_blank"
      title="LATAM Community Events Link"
      >LATAM Events</a
    >
  </li>
  <li>
    <a
      class="overlay-link"
      href="https://www.genesys.com/es-mx/events/gcsm-workshop-latam-region"
      target="_blank"
      title="LATAM Customer Sucess Events"
      >LATAM Customer Success Events</a
    >
  </li>
  <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
</ng-template>

<!--WEM Events-->
<ng-template #WEMEvents>
  <li>
    <a
      class="overlay-link"
      href="https://community.genesys.com/communities/community-home1/recent-community-events?communitykey=f6e20f73-2c94-4b44-be95-118216aafb4f"
      target="_blank"
      title="WEM Community Events Link"
      >WEM Events</a
    >
  </li>
  <ng-container *ngTemplateOutlet="defaultsEventForAllRoles"></ng-container>
</ng-template>
